import React from "react";
import { Quote } from "lucide-react";
import { resolveImage } from "../lib/api";

const Testimonials = ({ testimonials = [] }) => {
  if (!testimonials.length) return null;

  return (
    <section id="testimonials" className="relative py-16 md:py-20 bg-[color:var(--bg-2)]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex items-baseline gap-3 mb-8">
          <Quote className="w-4 h-4 text-[color:var(--coral)]" />
          <div className="text-[11px] tracking-[0.22em] uppercase text-[color:var(--muted)] font-medium">
            Kind words
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t, i) => (
            <div
              key={t.id || i}
              className="p-5 md:p-6 rounded-2xl bg-[color:var(--card)] border border-[color:var(--card-border)]"
            >
              <Quote className="w-4 h-4 text-[color:var(--coral)] mb-3" />
              <p className="font-display italic text-base md:text-lg leading-snug text-[color:var(--ink)]">
                “{t.quote}”
              </p>
              <div className="mt-4 flex items-center gap-3">
                {t.avatar && (
                  <img
                    src={resolveImage(t.avatar)}
                    alt={t.name}
                    className="w-9 h-9 rounded-full object-cover border border-[color:var(--card-border)]"
                  />
                )}
                <div className="min-w-0">
                  <div className="text-sm font-semibold truncate">{t.name}</div>
                  <div className="text-xs text-[color:var(--muted)] truncate">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
